module.exports = __webpack_public_path__ + "static/media/check_done.b66da2c4.svg";